<template>
  <div :style="{ maxWidth: maxWidth }">
    <nuxt-img v-bind="{ ...$attrs, ...$props }"></nuxt-img>
  </div>
</template>

<script>
export default {
  name: 'BlogImg',

  props: {
    maxWidth: {
      type: String,
      default: '100%',
    },

    src: {
      type: String,
      required: true,
    },

    alt: {
      type: String,
      default: null,
    },

    loading: {
      type: String,
      default: 'lazy',
    },
  },
};
</script>

<style lang="scss" scoped></style>
